<template>
    <!--   <div style="width:800px;height: 300px;overflow: auto;"> -->
    <div style="height:auto;">
        <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
            <Tag type="border" color="success" style="font-size: 15px;">{{this.nodetext}}</Tag>
            <Checkbox class="checkboxAll" :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll">全选</Checkbox>
        </div>
        <CheckboxGroup v-model="checkDispGroup" @on-change="checkAllGroupChange">
            <Checkbox v-for="item,index in items" :key="index" :label="item.text" :style="{display:index>=showCityCount?'none':'inline-block'}"></Checkbox>
            <p style="margin-top: 5px;">
                <Button type="dashed" size="small" @click="showAllCity">
                    {{showAll?'收起':'更多...'}}</Button>
            </p>
        </CheckboxGroup>
    </div>
</template>
<script>
export default {
    name: 'ReadMore',
    props: {
        nodetext: String,
        children: Array,
    },
    data() {
        return {
            showCityCount: 5,
            showAll: false,
            indeterminate: true,
            checkAll: false,
            checkAllGroup: [], //绑定提交数据
            checkDispGroup: [], //绑定显示数据,['成都','绵阳']
            items: this.children,
        }
    },
    created() {
        this.setChecked()
    },
    mounted() {
        //this.setChecked()
    },
    methods: {
        handleCheckAll(ckd) {
            let copy = []
            let dispCopy = []
            // let nodeItems = []
            this.items.forEach(function(item) {
                dispCopy.push(item.text)
                copy.push(item)
            })
            // if (this.indeterminate) {
            //     this.checkAll = false;
            // } else {
            //     this.checkAll = !this.checkAll;
            // }
            // this.indeterminate = false;

            // console.log(typeof ckd)
            // console.log(ckd.srcElement.checked)
            if (typeof ckd === "boolean") {
                if (ckd) {
                    this.checkDispGroup = dispCopy;
                    this.checkAllGroup = copy;
                    this.checkAll = ckd
                    this.indeterminate = false

                } else {
                    this.checkDispGroup = [];
                    this.checkAllGroup = [];
                    this.checkAll = false
                    this.indeterminate = false
                }
                //this.checkAll = ckd
                //this.indeterminate = !ckd   //全选中时状态于checkAll反向
            } else {
                if (this.indeterminate) {
                    this.checkAll = false;
                } else {
                    this.checkAll = !this.checkAll;
                }
                this.indeterminate = false;
                if (this.checkAll) {
                    this.checkDispGroup = dispCopy;
                    this.checkAllGroup = copy;
                } else {
                    this.checkDispGroup = [];
                    this.checkAllGroup = [];
                }

            }


            //this.$emit('onCheckChange',this.checkAllGroup)
            //console.log(this.checkAllGroup)
            // nodeItems = {
            //   name: this.nodetext,
            //   items: this.checkAllGroup
            // }
            // this.$emit('onTotalCheckedChange', nodeItems)
            this.sendChecked()
        },
        checkAllGroupChange(data) {
            console.log(data)
            let temp = new Set(data)
            let intersect = new Set(this.items.filter(x => temp.has(x.text))); //与原始集合求交集
            let copyArray = []
            intersect.forEach(v => copyArray.push(v)); //set转化为Array
            console.log(copyArray)

            if (data.length === this.items.length) {
                this.indeterminate = false;
                this.checkAll = true;
            } else if (data.length > 0) {
                this.indeterminate = true;
                this.checkAll = false;
            } else {
                this.indeterminate = false;
                this.checkAll = false;
            }
            this.checkAllGroup = copyArray;
            //this.$emit('onCheckChange',this.checkAllGroup)
            this.sendChecked()
        },
        showAllCity() {
            this.showAll = !this.showAll
            if (this.showAll) {
                this.showCityCount = this.items.length
            } else {
                this.showCityCount = 5
            }
        },
        // setChecked(t3) {
        //     //设置已checked状态
        //     // console.log('go setChecked-----------')
        //     // console.log(t3)
        //     // let k= Array.from(this.children,(x)=>x.text)
        //     // find 查找第一个,filter过滤

        //     // if (t3 && t3.length > 0) {
        //     //     let child = t3[0].children
        //     //     let chked = child.filter(item => item.selected === true)
        //     //     let chk = Array.from(chked, (x) => x.text) //转化成指定对象属性的数组
        //     //     this.checkDispGroup = chk
        //     //     this.checkAllGroup = chked;
        //     //     this.sendChecked()
        //     // } else {
        //     //     let chked = this.children.filter(item => item.selected === true)
        //     //     let chk = Array.from(chked, (x) => x.text) //转化成指定对象属性的数组
        //     //     this.checkDispGroup = chk
        //     //     this.checkAllGroup = chked;
        //     //     this.sendChecked()
        //     // }

        //     if (t3 && t3.length > 0) {
        //         let strArray=[]
        //         let objectArray=[]
        //         for (var i in t3) {
        //             let child = t3[i].children
        //             let chked = child.filter(item => item.selected === true)
        //             let chk = Array.from(chked, (x) => x.text) //转化成指定对象属性的数组
        //             strArray = strArray.concat(chk)
        //             objectArray=objectArray.concat(chked)
        //         }
        //         //console.log(strArray)
        //         this.checkDispGroup = strArray
        //         this.checkAllGroup = objectArray;

        //         //console.log(this.checkDispGroup,this.checkAllGroup,this.items)
        //         this.sendChecked()
        //     } else {
        //         let chked = this.children.filter(item => item.selected === true)
        //         let chk = Array.from(chked, (x) => x.text) //转化成指定对象属性的数组
        //         this.checkDispGroup = chk
        //         this.checkAllGroup = chked;
        //         this.sendChecked()
        //     }

        // },

        setChecked(t3) {
            // console.log('t3=============>')
            // console.log(t3)
            if (t3 && t3.children.length > 0) {
                let strArray = []
                let objectArray = []
                let child = t3.children
                let chked = child.filter(item => item.selected === true)
                if(chked.length>0){
                      this.indeterminate = true;
                      this.checkAll = false;
                }
                // if(child.length===chked.length){
                //     console.log('全选----->>>>')
                //     this.indeterminate = false;
                //     this.checkAll = true;
                // }else if(chked.length>0){
                //     console.log('半选----->>>>')
                //     this.indeterminate = true;
                //     this.checkAll = false;
                // }else{
                //     console.log('空----->>>>')
                //      this.indeterminate = false;
                //     this.checkAll = false;
                // }
                let chk = Array.from(chked, (x) => x.text) //转化成指定对象属性的数组
                strArray = strArray.concat(chk)
                objectArray = objectArray.concat(chked)

                //console.log(strArray)
                this.checkDispGroup = strArray
                this.checkAllGroup = objectArray;
                this.sendChecked()
            } else {
                let child =this.children
                let chked = child.filter(item => item.selected === true)
                if(chked.length>0){
                      this.indeterminate = true;
                      this.checkAll = false;
                }
                //  if(child.length===chked.length){
                //     this.indeterminate = false;
                //     this.checkAll = true;
                // }else if(chked.length>0){
                //     this.indeterminate = true;
                //     this.checkAll = false;
                // }else{
                //      this.indeterminate = false;
                //     this.checkAll = false;
                // }
                let chk = Array.from(chked, (x) => x.text) //转化成指定对象属性的数组
                this.checkDispGroup = chk
                this.checkAllGroup = chked;
                this.sendChecked()
            }

        },
        getChecked() {
            //console.log(this.checkAllGroup)
        },
        sendChecked() {

            let nodeItems = {
                name: this.nodetext,
                items: this.checkAllGroup
            }
            //console.log('sendChecked==========>')
            //console.log(nodeItems)
            this.$emit('onTotalCheckedChange', nodeItems)
        }
    },
    watch: {
        // checkDispGroup: {
        //     handler(val) {
        //         // console.log('go handler-----------')
        //     }
        // }
    }
}
</script>
<style>
</style>